export const modal = {
  overlay: {
    background: "rgba(0, 0, 0, 0.75)", // TODO: Use theme color
    zIndex: "overlay",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflowX: "hidden",
    "@supports (height: 100dvh)": {
      height: "100dvh",
      maxHeight: "100dvh",
    },
    "@supports not (height: 100dvh)": {
      height: "100vh",
      maxHeight: "100vh",
    },
  },
  content: {
    m: 0,
    bg: "beige100",
    p: 0,
    fontFamily: "textSans",
    position: "relative",
    lineHeight: "text", // update to match theme
  },
  actions: {
    display: "flex",
    justifyContent: "center",
  },
};

export const dialogModalOverlay = {
  ...modal.overlay,
};

export const dialogModalContent = {
  ...modal.content,
  mx: "s300",
  width: ["full"],
  maxWidth: "content03",
  py: ["s700", "s900"],
  px: ["s400", "s800"],
};

export const dialogModalContentWide = {
  ...dialogModalContent,
  maxWidth: "small",
};

export const dialogModalActions = {
  ...modal.actions,
};

export const utilityModalOverlay = {
  ...modal.overlay,
};

export const utilityModalContent = {
  ...modal.content,
  display: "flex",
  flexDirection: "column",
  py: ["s800", null, "s600"],
  bg: "beige100",
};

export const utilityModalBody = {
  px: ["s400", null, "s800"],
  py: "s50",
  flexGrow: 1,
  overflowY: "auto",
  overflowX: "hidden",
  textAlign: "center",
};

export const utilityModalActions = {
  ...modal.actions,
  px: ["s700", "s1100"],
  mt: ["s700", "s800"],
  mb: ["s400", "s800"],
};

export const utilityModalBack = {
  position: "absolute",
  top: ["s400", "s700"],
  left: ["s400", "s700"],
  transform: "rotate(180deg) translateY(-4px)",
};

export const utilityModalBackCloseIcon = {
  position: "absolute",
  top: ["s100"],
  right: ["s100"],
  width: 40,
  height: 40,
};

export const drawerModalOverlay = {
  "&[data-reach-dialog-overlay]": {
    ...modal.overlay,
    justifyContent: "flex-end",
  },
};

export const drawerModalContent = {
  "&[data-reach-dialog-content]": {
    ...modal.content,
    display: "flex",
    flexDirection: "column",
    width: ["screenWidth", "auto"],
  },
};

export const drawerModalBody = {
  flexGrow: 1,
  overflowY: "auto",
  overflowX: "hidden",
  color: "grey700",
  width: ["screenWidth", 400],
  height: "screenHeight",
  position: "relative",
};

export const flyoutOverlay = {
  "&[data-reach-dialog-overlay]": {
    ...modal.overlay,
    justifyContent: "flex-end",
  },
};

export const flyoutContent = {
  "&[data-reach-dialog-content]": {
    ...modal.content,
    display: "flex",
    flexDirection: "column",
    width: ["screenWidth", "auto"],
    bg: "white",
  },
};
